import { Params } from 'react-router-dom';
import { GoogleAdsEditConnector } from '@components/layouts/Connectors/GoogleAdsConnector/GoogleAdsEditConnector';
import { UserStateData } from '@/types/types';
import { connectorEditLoader } from '@/routes/connectorLoaders/commons';
import { FBEditConnector } from './FBConnector/FBEditConnector';
import { FBInfoConnector } from './FBConnector/FBInfoConnector';
import { FBErrorConnector } from './FBConnector/FBErrorConnector';
import { GoogleAdsInfoConnector } from './GoogleAdsConnector/GoogleAdsInfoConnector';
import { GoogleAdsErrorConnector } from './GoogleAdsConnector/GoogleAdsErrorConnector';
import { GoogleAnalyticsEditConnector } from './GoogleAnalyticsConnector/GoogleAnalyticsEditConnector';
import { GoogleAnalyticsInfoConnector } from './GoogleAnalyticsConnector/GoogleAnalyticsInfoConnector';
import { ShopifyInfoConnector } from './ShopifyConnector/ShopifyInfoConnector';
import { DataForSeoInfoConnector } from './DataForSeoConnector/DataForSeoInfoConnector';
import { DataForSeoEditConnector } from './DataForSeoConnector/DataForSeoEditConnector';
import { useOrganizationStore } from '@/stores/organizationStore';
import { LinkedinEditConnector } from './LinkedinConnector/LinkedinEditConnector';
import { LinkedinInfoConnector } from './LinkedinConnector/LinkedinInfoConnector';
import { LinkedinErrorConnector } from './LinkedinConnector/LinkedinErrorConnector';

interface ConnectorComponents {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  editLoader: (params: Params, request: Request, user: UserStateData) => Promise<any>;
  addLoader?: (params: Params) => Promise<unknown>;
  addComponent?: JSX.Element;
  editComponent: JSX.Element;
  infoComponent: JSX.Element;
  errorComponent: JSX.Element;
}

const connectorsMap = new Map<string, ConnectorComponents>([
  [
    'facebook-ads',
    {
      editLoader: connectorEditLoader('facebook-ads', 'Facebook Ads'),
      editComponent: <FBEditConnector />,
      infoComponent: <FBInfoConnector />,
      errorComponent: <FBErrorConnector />,
    },
  ],
  [
    'google-ads',
    {
      editLoader: connectorEditLoader('google-ads', 'Google Ads'),
      editComponent: <GoogleAdsEditConnector />,
      infoComponent: <GoogleAdsInfoConnector />,
      errorComponent: <GoogleAdsErrorConnector />,
    },
  ],
  [
    'google-analytics',
    {
      editLoader: connectorEditLoader(
        'google-analytics',
        'Google Analytics',
        'advertising',
      ),
      editComponent: <GoogleAnalyticsEditConnector />,
      infoComponent: <GoogleAnalyticsInfoConnector />,
      errorComponent: <GoogleAdsErrorConnector />,
    },
  ],
  [
    'shopify',
    {
      editLoader: connectorEditLoader('shopify', 'Shopify', 'advertising'),
      editComponent: <ShopifyInfoConnector />,
      infoComponent: <ShopifyInfoConnector />,
      errorComponent: <GoogleAdsErrorConnector />,
    },
  ],
  [
    'dataforseo',
    {
      editLoader: connectorEditLoader('dataforseo', 'Dataforseo', 'advertising'),
      editComponent: <DataForSeoEditConnector />,
      infoComponent: <DataForSeoInfoConnector />,
      errorComponent: <DataForSeoInfoConnector />,
    },
  ],
  [
    'linkedin-ads',
    {
      editLoader: connectorEditLoader('linkedin-ads', 'Linkedin', 'advertising'),
      editComponent: <LinkedinEditConnector />,
      infoComponent: <LinkedinInfoConnector />,
      errorComponent: <LinkedinErrorConnector />,
    },
  ],
]);

export const getConnectorsMap = (): Map<string, ConnectorComponents> => {
  const permissions = useOrganizationStore.getState().selectedOrganization?.permissions;
  if (!permissions) return connectorsMap;

  const allowedIds = permissions.organization_available_connectors?.split(',') ?? [];
  return new Map(
    Array.from(connectorsMap.entries()).filter(([key]) => allowedIds.includes(key)),
  );
};
